<template lang='pug'>
  v-flex(:class="classObj", :title='component.label' style="position: relative")
    v-combobox.ma-0.pa-0(
      v-if='component.editable'
      v-model='data'
      :items="items"
      :multiple="component.multiple"
      :label='label'
      :placeholder="component.placeholder"
      :required="component.required"
      :disabled="component.disabled"
      :suffix="component.suffix"
      :prefix="component.prefix || ' '"
      :small-chips="component.noChips ? false : true"
      hide-details
      :return-object="false"
      :loading="loading"
      @change="onChangeInner"
      @focus="onFocus"
      )
      template(v-slot:no-data="")
        v-list-tile
          v-list-tile-content
            v-list-tile-title
              | Pressione&nbsp;
              kbd enter
              | &nbsp;para criar um novo item.
      template(v-slot:item='{ index, item }')
        v-list-tile-content {{ item.text }}
        v-spacer
        v-list-tile-action(v-if="item.remote" @click.stop='')
          v-btn(icon @click.stop.prevent='removeItem(item)')
            v-icon clear
    v-select.ma-0.pa-0(v-else
      v-model='data'
      :items='items'
      :multiple="component.multiple"
      :label='label'
      :placeholder="component.placeholder"
      :required="component.required"
      :disabled="component.disabled"
      :suffix="component.suffix"
      :prefix="component.prefix || ' '"
      clearable=true,
      small-chips
      hide-details
      :return-object="false"
      @change="onChange"
      )
    field-info(v-if="!this.component.hiddenInfo || this.component.hiddenInfo == false" :field="id" :component="component" :resultForm.sync="resultForm")
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import apiFormFields from '@/api/formFields'
import FieldInfo from '../buttons/FieldInfo'

export default {
  name: 'u-select',

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    resultForm: {
      type: Object
    },
    value: {}
  },

  components: {
    FieldInfo
  },

  computed: {
    ...mapState({
      company: (state) => state.ultraFetal.company
    }),
    items () {
      let arr = []

      const remoteItems = this.remoteItems.map(item => ({ text: item, value: item, valueSort: item.toLowerCase(), remote: true }))
      const componentItems = this.component.items.map(item => {
        if (item.text) {
          return {
            text: this.t(this.id + '.items.' + item.value + '.text', item.text),
            value: item.value
          }
        } else {
          return {
            text: this.t(this.id + '.items.' + item + '.text', item),
            value: item
          }
        }
      })

      arr = componentItems.concat(_.sortBy(remoteItems, ['valueSort']))

      if (this.component.editable) {
        arr.unshift({ header: 'Selecione ou digite uma novo item' })
      }

      return arr
    },
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  watch: {
    value (val) {
      this.data = val
    },
    data (val) {
    }
  },

  data () {
    return {
      loading: false,
      data: null,
      editing: null,
      index: -1,
      remoteItems: []
    }
  },

  methods: {
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        // data.for
        item.value = item.text
        this.editing = null
        this.index = -1
      }
    },
    async onFocus (event) {
      console.log('focus', event)
      this.loadRemoteItems()
    },
    onChangeInner (event) {
      this.onChange(event)
      this.addItem(event)
      this.$emit('change', event)
    },
    async addItem (newItem) {
      if (!newItem) return

      const isNewItem = this.items.filter(item => {
        if (!item.value) return false
        return _.lowerCase(item.value) === _.lowerCase(newItem)
      })
      if (isNewItem.length > 0) return

      await apiFormFields.addItem(this.id, this.company.iuid, newItem)
      console.log(newItem)
      this.loadRemoteItems()
    },
    async removeItem (item) {
      this.loading = true

      await apiFormFields.delItem(this.id, this.company.iuid, item.value)
      await this.loadRemoteItems()

      this.loading = false
    },
    async loadRemoteItems () {
      this.loading = true

      const formFields = await apiFormFields.findByField(this.id, this.company.iuid)
      if (formFields && formFields.items) {
        this.remoteItems = formFields.items
      }

      this.loading = false
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Select.vue